<template>
  <LineChart
    :width="width"
    :height="height"
    :chart-data="data"
    :options="options"
  />
</template>
 
<script>
export default {
  props: {
    reportData: {
      type: Object,
      default: null,
    },
    width: {
      type: Number,
      default: 0,
    },
    height: {
      type: Number,
      default: 0,
    },
  },
  mounted(){
    
  },
  computed: {
 
    data() {
      let expenditure = this.reportData.expenditure
      let income = this.reportData.income 
       
      let labels = []
      let expenditureData = []
      let incomeData = []
   
      for(let i in expenditure) {
        expenditureData.push(expenditure[i])
        labels.push(i)
        incomeData.push(income[i])
      }
      

      return {
        labels: labels,
        datasets: [
          {
            label: "# of Votes",
            data: incomeData,
            borderWidth: 1,
            borderColor: "#3160D8",
            borderDash: [20, 2],

            backgroundColor: "transparent",
            pointBorderColor: "transparent",
          },
          {
            label: "# of Votes",
            data:expenditureData,
            borderWidth: 1,
            borderDash: [15, 5],
            borderColor: "#BCBABA",
            backgroundColor: "transparent",
            pointBorderColor: "transparent",
          },
        ],
      };
    },
    options() {
      return {
        legend: {
          display: false,
        },
        scales: {
          xAxes: [
            {
              ticks: {
                fontSize: "12",
                fontColor: "#777777",
              },
              gridLines: {
                display: false,
              },
            },
          ],
          yAxes: [
            {
              ticks: {
                fontSize: "12",
                fontColor: "#777777",
                callback: function (value) {
                  return "￥" + value;
                },
              },
              gridLines: {
                color: "#D8D8D8",
                zeroLineColor: "#D8D8D8",
                borderDash: [2, 2],
                zeroLineBorderDash: [2, 2],
                drawBorder: false,
              },
            },
          ],
        },
      };
    },
  },
};
</script>
